export default class TwoFactorTokenError extends Error {
	constructor(message) {
		super(message)
		this.name = 'TwoFactorTokenError'
	}
}
